import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_component_Datepicker, _mergeProps({
      key: _ctx.reloaded,
      modelValue: _ctx.date,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
        _ctx.updateDate
      ],
      locale: _ctx.datePickerLocale,
      "now-button-label": _ctx.$t('components.datepicker.nowText'),
      "partial-range": false,
      placeholder: _ctx.$t('components.datepicker.placeholder'),
      style: _ctx.cssProps,
      "auto-apply": "",
      format: "dd/MM/yyyy | HH:mm",
      "preview-format": "dd/MM/yyyy | HH:mm",
      range: _ctx.range,
      "show-now-button": "",
      "time-picker-inline": _ctx.timePickerInline
    }, _ctx.startTime ? { 'start-time': _ctx.startTime } : {}, {
      required: _ctx.required,
      "is-24": true
    }), _createSlots({ _: 2 }, [
      (_ctx.showCustomTimeButtons)
        ? {
            name: "right-sidebar",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setTime(7, 0)), ["stop"]))
                }, " 07:00 "),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setTime(19, 0)), ["stop"]))
                }, " 19:00 ")
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1040, ["modelValue", "locale", "now-button-label", "placeholder", "style", "range", "time-picker-inline", "onUpdate:modelValue", "required"]))
  ]))
}